export const Version = {
	version: '3.20.0.16'
};
